module.exports = __webpack_public_path__ + "media/images/photos/dent-repair-d3fe58db5617839141ac63ea062bfcac.jpg";